module.exports = __webpack_public_path__ + "img/consilium-eeuu.5550a75d.png";